import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const scrollEl = document.querySelector('.main-scroll');
    if (scrollEl) scrollEl.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
